import React from 'react';
import { useTranslation } from 'react-i18next';

const NUM_OPS = ['eq', 'gt', 'lt', 'between', 'is_empty', 'not_empty'];
const OP_KEY  = { eq: 'equals', gt: 'greaterThan', lt: 'lessThan', between: 'between', is_empty: 'isEmpty', not_empty: 'notEmpty' };

export default function NumberFilter({ value, onChange }) {
  const { t } = useTranslation();
  const op   = value?.op    || 'eq';
  const val  = value?.value  ?? '';
  const val2 = value?.value2 ?? '';
  const noInput = op === 'is_empty' || op === 'not_empty';

  const update = (patch) => onChange({ op, value: val, value2: val2, ...patch });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <select
        value={op}
        onChange={e => update({ op: e.target.value, value: '', value2: '' })}
        style={S.select}
      >
        {NUM_OPS.map(o => (
          <option key={o} value={o}>{t(`table.${OP_KEY[o]}`)}</option>
        ))}
      </select>
      {!noInput && (
        <input
          type="number"
          value={val}
          onChange={e => update({ value: e.target.value })}
          placeholder={t('filterPopover.value')}
          style={S.input}
          autoFocus
        />
      )}
      {op === 'between' && (
        <input
          type="number"
          value={val2}
          onChange={e => update({ value2: e.target.value })}
          placeholder={t('table.to')}
          style={S.input}
        />
      )}
    </div>
  );
}

const S = {
  select: {
    width: '100%', padding: '6px 8px',
    background: 'var(--bg-elevated)', border: '1px solid var(--border)',
    borderRadius: 6, color: 'var(--text-primary)', fontSize: 12,
    fontFamily: 'inherit', cursor: 'pointer',
  },
  input: {
    width: '100%', padding: '6px 8px',
    background: 'var(--bg-elevated)', border: '1px solid var(--border)',
    borderRadius: 6, color: 'var(--text-primary)', fontSize: 12,
    fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box',
  },
};
